import { useEffect, useState } from 'react';

import { DOMINO_LOGIN_FLAG } from '@domui-domain/constants';
import { useFetchDominoMetaConfig } from '@domui-hooks/useFetchDominoMetaConfig';

import { useLogger } from '@hooks/logger';

import { LogLevel } from '@typings/graphql';

export const useDominoLoginFlag = () => {
  const [data, setData] = useState<Boolean | null>(null);
  const [loading, setLoading] = useState<Boolean | null>(null);
  const { addLog } = useLogger();
  const { fetchDominoMetaConfig } = useFetchDominoMetaConfig();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const result = await fetchDominoMetaConfig(DOMINO_LOGIN_FLAG);
      const flag = String(result[DOMINO_LOGIN_FLAG])?.toLowerCase() === 'true';
      setData(flag);
      setLoading(false);

      addLog({
        level: LogLevel.Info,
        message: `useDominoLoginFlag: Domino Login Flag Fetched ${flag}`,
      });
    };
    fetchData();
  }, []);

  return { data, loading };
};
